module.exports = __webpack_public_path__ + "static/media/Bg-iphone1-en.5ac45ff8.png";